import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';

export const localePrefix = 'as-needed';

export const routing = defineRouting({
  locales: ['en', 'ko'],
  localePrefix,
  defaultLocale: 'en',
  localeCookie: {
    maxAge: 60 * 60 * 24 * 365, // 1 year
  },
});

export const { Link, redirect, permanentRedirect, usePathname, useRouter } =
  createNavigation(routing);
